import { DataAnalyticsEvent } from '../../services/data-analytics/data-analytics.domain';

export interface DataAnalyticsTaggingConfiguration {
  buildTag: string;
  locale: string;
  environment: string;
  dataLayerScriptUrl: string;
  dataLayerEnabled: boolean;
  routeStateTaggingEventMapper: DataAnalyticsTaggingEvents
}

export interface DataAnalyticsTaggingEvents {
  [key: string]: DataAnalyticsTaggingEvent
}

export interface DataAnalyticsTaggingEvent extends DataAnalyticsEvent {
  event?: DataAnalyticsTaggingEventType;
  site?: DataAnalyticsTaggingSite;
  page?: Partial<DataAnalyticsTaggingPage>;
  link?: DataAnalyticsTaggingLink
  user?: DataAnalyticsTaggingUser;
  error?: DataAnalyticsTaggingError;
  process?: DataAnalyticsTaggingProcess;
  application?: DataAnalyticsApplication;
  search?: DataAnalticsTaggingSearch;
}

export enum DataAnalyticsTaggingEventType {
  PAGE_CHANGE = 'pageChange',
  PAGE_LOAD = 'pageLoad',
  MODAL_CLOSE = 'modalClose',
  ERROR = 'error',
  LINK_CLICK = 'linkClick',
  BUTTON_CLICK = 'buttonClick',
  SEARCH = 'search'
}

export interface DataAnalyticsTaggingSite {
  language: string;
  environment: string;
  version: string;
}

export interface DataAnalyticsTaggingPage {
  name: string;
  section: string;
  subSection1: string;
  subSection2: string;
  subSection3: string;
  subSection: string;
  customPageName: string;
  appliedFilter: string;
  tabName: string;
  modalName: string;
  videoSection: string;
  mediaName: string;
  mediaType: string;
  institutionNumber: string;
  accountType: string;
  currencyType: string;
  transferFrequency: string;
  amountTransfer: string;
  startDate: string;
  contributionType: string;
  flowType: string
}

export interface DataAnalyticsTaggingLink {
  name: string;
  type: string;
}

export enum DataAnalyticsTaggingAuthenticationStatus {
  AUTHENTICATED = 'authenticated',
  NOT_AUTHENTICATED ='not-authenticated'
}

export interface DataAnalyticsTaggingUser {
  authenticationStatus: DataAnalyticsTaggingAuthenticationStatus
}

export enum DataAnalyticsTaggingErrorCode {
  ERROR_500_CODE = 500,
  ERROR_404_CODE = 404,
  ERROR_403_CODE = 403
}

export interface DataAnalyticsTaggingError {
  code: DataAnalyticsTaggingErrorCode;
  message?: string;
}

export interface DataAnalyticsTaggingProcess {
  processName: string;
  processType?: string;
}

export interface DataAnalticsTaggingSearch {
  term?: string;
  results?: string;
  type?: string;
}

export interface DataAnalyticsApplication {
  accountInteractions?: string;
  equityType?: string;
  priceType?: string;
}

export type ModalStepAction = 'start' | 'complete';
